<div class="page-header">
  <div class="header-start">
    <h3 class="title">
      <ng-container *ngIf="operation == 'view'">View Customer</ng-container>
      <ng-container *ngIf="operation == 'edit'">Edit Customer</ng-container>
      <ng-container *ngIf="operation != 'edit' && operation != 'view'">Add Customer</ng-container>
    </h3>
  </div>
  <div class="header-end">

  </div>
</div>
<nav aria-label="breadcrumb">
  <ol class="breadcrumb breadcrumb-sm d-flex justify-content-start">
    <li class="breadcrumb-item"><a class="link" style="cursor: pointer;" (click)="navigateToCustomerList()">Customers</a></li>
    <li class="breadcrumb-item active"><span>{{operation == 'edit'? 'Edit Customer': operation == 'view'? 'View Customer': 'Add Customer'}}</span></li>
  </ol>
</nav>
<div class="stepper-gap"> 
<mat-stepper #stepper [selectedIndex]="currentTabIndex" color="primary" [linear]="operation != 'edit' && operation != 'view'" (selectionChange)="onToggleTab($event)">
  <mat-step label="Customer Info" [stepControl]="nextStepValidForm">
    <form class="content" (ngSubmit)="onFormSubmit(f)" #f="ngForm" autocomplete="off" *ngIf="stepConfig.info == 1">
      <spinner [id]="'customer-info-data'" [show]='loading'></spinner>
      <div class="row g-3">
        <div class="col-sm-6 col-xl-4">
          <div class="form-group">
            <form #customerNameFormRef="ngForm" [formGroup]="customerNameForm">
              <mat-form-field class="w-100"  [color]="isCustomerNameEmpty ? 'warn' : 'primary'">
                <mat-label>Customer Name</mat-label>
                <input matInput *ngIf="operation !== 'view'" type="text" maxlength="25"
                  (paste)="onPaste($event,'customerName')" (keypress)="onlyAlphabet($event)" placeholder="Customer Name"
                  (input)="onNameEntered($event)" name="name" formControlName="customerName" [value]="customerDetails?.customerName" required>
                <input matInput *ngIf="operation === 'view'" readonly  formControlName="customerName" [value]="customerDetails.customerName">
              </mat-form-field>
            </form>
          </div>
        </div>
        <div class="col-sm-6 col-xl-4">
          <div class="form-group">
          <form #customerEmailFormRef="ngForm" [formGroup]="customerEmailForm">
            <mat-form-field class="w-100">
              <mat-label >Communication Email Address</mat-label>
              <input matInput *ngIf="operation !== 'view'" type="email"
              name="email" formControlName="customerEmail"  (input)="validateEmail($event)" [value]="customerDetails?.email" required maxlength="50">
              <input matInput *ngIf="operation === 'view'" readonly  formControlName="customerEmail" [value]="customerDetails.email">
              <mat-hint class="text-danger" *ngIf="customerEmailFormRef.touched && !isEmailValid ">Please enter a valid email</mat-hint>
            </mat-form-field>
          </form>
        </div>
        </div>
        <div class="col-sm-6 col-xl-4">
          <div class="form-group">
            <form #primaryMobileFormRef="ngForm" [formGroup]="primaryMobileForm">

              <mat-form-field class="w-100">
                <mat-label>Primary Contact Number</mat-label>
                <ngx-mat-intl-tel-input *ngIf="operation !== 'view'"
                  [enablePlaceholder]="true" [enableSearch]="true"
                  [maxLength]="15" [phoneValidation]="true"
                  [cssClass]="'custom'"
                  [searchCountryFlag]="true"
                  [preferredCountries]="['in','us', 'ca']"
                  [required]="true"
                  name="primaryMobileNo"
                  formControlName="primaryMobileNo" #phone (input)="checkLength($event, 'primary')">
                </ngx-mat-intl-tel-input>
                <mat-error *ngIf="!isPrimaryMobileNoValid">
                  *Invalid Phone Number
                </mat-error>
                <input matInput *ngIf="operation === 'view'" readonly formControlName="primaryMobileNo" [value]="customerDetails.primaryMobileNo">
              </mat-form-field>
            </form>
          </div>
        </div>

        <div class="col-sm-6 col-xl-4">
          <form #secondaryMobileFormRef="ngForm" [formGroup]="secondaryMobileForm">
            <mat-form-field class="w-100">
              <mat-label>Secondary Contact Number</mat-label>
              <ngx-mat-intl-tel-input *ngIf="operation !== 'view'"
                [enablePlaceholder]="true" [enableSearch]="true"
                [maxLength]="15" [phoneValidation]="true"
                [cssClass]="'custom'"
                [searchCountryFlag]="true"
                [preferredCountries]="['in','us', 'ca']"
                [enablePlaceholder]="true"
                [required]="false"
                name="secondaryMobileNo"
                formControlName="secondaryMobileNo" #phone (input)="checkLength($event, 'secondary')">
              </ngx-mat-intl-tel-input>
              <mat-error *ngIf="!isSecondaryMobileNoValid">
                *Invalid Phone Number
              </mat-error>
              <input matInput *ngIf="operation === 'view'" readonly [value]="customerDetails.secondaryMobileNo || '-'">
            </mat-form-field>
          </form>
        </div>

        <div class="col-sm-6 col-xl-4">
          <mat-form-field class="w-100">
            <mat-label>Communication Address</mat-label>
            <input matInput *ngIf="operation !== 'view'" type="text" placeholder="Complete Address"
              [(ngModel)]="customerDetails.address" name="com_address" maxlength="100"
              (input)="onCommAddressChanged($event)">
            <input matInput *ngIf="operation === 'view'" readonly [value]="customerDetails.address || '-'">
          </mat-form-field>



        </div>
        <div class="col-sm-6 col-xl-4">
          <mat-form-field class="w-100">
            <mat-label>Billing Address</mat-label>
            <input matInput *ngIf="operation !== 'view'" type="text" placeholder="Complete Address"
              [(ngModel)]="customerDetails.billingAddress" name="billing_address" maxlength="100"
              (input)="onBillingAddressChanged($event)">
            <input matInput *ngIf="operation === 'view'" readonly [value]="customerDetails.billingAddress || '-'">
          </mat-form-field>

          <mat-checkbox class="negetive-top" *ngIf="operation !== 'view'" [disabled]="!customerDetails.address"
            [checked]="billingAddressToggleFlag" (click)="billingAddressToggle()">Communication & Billing Address is
            same</mat-checkbox>
        </div>

        <ng-container *ngIf="isCustomerDropdownRequired">
          <div class="col-sm-6 col-xl-4" *ngFor="let dropdown of customerDropDownValues">

            <mat-form-field class="w-100" *ngIf="operation != 'new'">
              <mat-label>Customer Type</mat-label>
              <input matInput *ngIf="operation !== 'view'" type="text" placeholder="Complete Address"
                [(ngModel)]="customerDetails.billingAddress" name="billing_address" maxlength="100"
                (input)="onBillingAddressChanged($event)">
              <input matInput readonly [value]="selectedTypeValues[dropdown.label] || '-'">
            </mat-form-field>

            <ng-container *ngIf="operation == 'new'">
              <!-- <label [attr.for]="dropdown.label"><strong>Customer Type</strong> <span
                  class="text-danger">*</span></label> -->
              <ng-select class="p-0" name="customerList" [items]="dropdown.values" placeholder="Select Customer Type"
                bindLabel="cust_type_name" bindValue="cust_type_uuid" [multiple]="false"
                [(ngModel)]="selectedTypeValues[dropdown.label]" (change)="onTypeChanged()">
              </ng-select>
            </ng-container>
          </div>
        </ng-container>
        <div *ngIf="customerAdmin || customerAdminEmail" class="col-sm-6 col-xl-4">
          <mat-form-field class="w-100">
            <mat-label>Customer Admin</mat-label>
            <!-- <input matInput *ngIf="operation === 'view'" type="text" placeholder="Complete Address"
              [(ngModel)]="customerDetails.billingAddress" name="billing_address" maxlength="100"
              (input)="onBillingAddressChanged($event)"> -->
            <input matInput readonly 
              [value]="customerAdmin?.email || customerAdminEmail || customerDetails.customerAdminEmail || ''">
          </mat-form-field>
        </div>
      </div>


      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" mat-raised-button (click)="navigateToCustomerList()">Cancel</button>
        <button type="submit" *ngIf="operation !== 'view'" mat-raised-button color="primary" [disabled]="f.invalid || isCustomerNameEmpty ||
        !isEmailValid  || (isCustomerDropdownRequired && !areCustomerAttributesFilled) ||
        !primaryMobileFormRef.form.valid ||
        !secondaryContactValid"> {{operation == 'new'?
          'Continue': 'Update'}}
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step label="Add Admin" [stepControl]="customerAdminForm">
    <ng-container *ngIf="stepConfig.admin == 1">
      <div class="content">
        <spinner [id]="'customer-admin-data'" [show]='loading'></spinner>
            <app-add-customer-admin [customerId]="customerId" [customerName]="customerDetails.customerName"
          [operation]="operation" [customerDetails]="customerAdminInfoDetails " (formEmitter)="catchCustomerAdminForm($event)"
          (customerAdminInfoDetailsEmitter)="customerAdminInfoDetailsEmitter($event)"
          (dataEmitter)="($event ? stepper.next() : null)"></app-add-customer-admin>
      </div>
    </ng-container>
  </mat-step>
  <mat-step label="Assign Resources" >
    <ng-container *ngIf="stepConfig.resources == 1">
      <div *ngFor="let application of applicationsList">
        <ng-container *ngIf="(applicationSelectedStatus?.[application?.applicationName] && operation == 'view') || operation != 'view'">
          <div class="card card-resource-container">
            <div class="card-header">
              <mat-checkbox [disabled]="operation === 'view'"
                            [checked]="applicationSelectedStatus[application.applicationName] ? true : false"
                            (click)="toggleApplicationSelectedStatus(application.applicationName,application.applicationId)">
                {{application.applicationName}}
              </mat-checkbox>
            </div>
            <div class="card-body p-0"
                 *ngIf="applicationSelectedStatus[application.applicationName] && appsListWithResources">
              <app-assign-resources [disabled]="operation === 'view'" [applicationId]="application.applicationId"
                                    [applicationListWithResources]="appsListWithResources" [customerId]="customerId"
                                    [applicationName]="application.applicationName" (getData)="getdata($event)">
              </app-assign-resources>
            </div>
          </div>
        </ng-container>
      </div>


      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" mat-raised-button (click)="navigateToCustomerList()">Cancel</button>
        <button type="submit" *ngIf="operation !== 'view'"
        (click)="assignOrUpdateResources()" mat-raised-button color="primary"> {{operation == 'new'? 'Save': 'Update'}}
        </button>
      </div>
    </ng-container>
  </mat-step>
</mat-stepper>
</div>